import { ServiceProvider } from '@models';

export interface ServiceProviderState {
  serviceProviders: ServiceProvider[];
  fetchedAt: Date | null;
}

export const initialServiceProviderState: ServiceProviderState = {
  serviceProviders: [],
  fetchedAt: null,
};


